import { Components, Theme } from "@mui/material"

export const MuiTabs: Required<Components<Theme>>["MuiTabs"] = {
  styleOverrides: {
    root: ({ theme: { palette } }) => ({
      minHeight: "unset",
      height: "28px",
      width: "100%",
      backgroundColor: palette["bg-secondary"],
      "& .MuiTabs-indicator": {
        display: "none",
      },
    }),
  },
}
